'use client';

import { c as _c } from "react/compiler-runtime";
import { Clock, Eye, Zap } from 'lucide-react';
const trustItems = [{
  icon: Clock,
  text: 'No long-term commitments'
}, {
  icon: Eye,
  text: 'Free to browse opportunities'
}, {
  icon: Zap,
  text: 'Built for fast execution'
}];
export function TrustSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="py-14 bg-white"><div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">{trustItems.map(_temp)}</div></div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(item) {
  return <div key={item.text} className="flex items-center gap-3"><item.icon className="h-5 w-5 text-gray-400" /><span className="text-sm font-medium text-gray-600">{item.text}</span></div>;
}